import { optOutText } from '../utils/textContentStrings'
import s from './CampaignCard.module.scss'

export function campaignTemplateToText(
  template,
  userName,
  hotelName,
  hasMaxLength = true
) {
  const url = 'on.savibook/hsa88'

  let shortTemplate = template

  if (template.length > 180 && hasMaxLength) {
    shortTemplate = template.substring(0, 180) + '...'
  }

  return shortTemplate
    .replace(/@\[(\S+)\]\((__)?(\S+)(__)?\)/gm, '$1')
    .replace('guestName', userName)
    .replace('hotelName', hotelName)
    .replace('inviteLink', '|' + url + '|')
    .replace(optOutText, '')
    .split('|')
    .map((part, i) => {
      if (part.includes('on.savibook')) {
        return (
          <span className={s.bubbleLink} key={`t-${i}`}>
            [link]
          </span>
        )
      } else {
        return <span key={`t-${i}`}>{part}</span>
      }
    })
}
